module.exports = __webpack_public_path__ + "4d3148e17d3fdfae12e505366fcd56c0.MP3";